import { useEffect } from 'react';

/** Fallback when S3 serves CRA index for /Schedules — load static Next export. */
export default function DashboardStaticRedirect({ page }) {
  useEffect(() => {
    window.location.replace(`/${page}.html`);
  }, [page]);

  return null;
}
